"use client";

import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { AnimatePresence, motion } from "framer-motion";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Providers } from "./providers";
import ErrorBoundary from "@/components/ErrorBoundary";
import { clearReloadCount } from "@/lib/errorReload";

export default function LayoutShell({
	children,
}: {
	children: React.ReactNode;
}) {
	const pathname = usePathname() ?? "/";
	useEffect(() => {
		// clear reload counter on successful navigation - so next error gets fresh 2 tries
		clearReloadCount();
	}, [pathname]);

	return (
		<Providers>
			<Header />
			<ErrorBoundary key={pathname}>
				<AnimatePresence mode="wait">
					<motion.div
						key={pathname}
						initial={{ opacity: 0, y: 50 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
					>
						<ErrorBoundary>{children}</ErrorBoundary>
					</motion.div>
				</AnimatePresence>
			</ErrorBoundary>
			<Footer />
		</Providers>
	);
}
